/* eslint-disable react-hooks/exhaustive-deps */

import { CURRENCY_LABEL_FORMATS, getCurrencyOptions, isIdEqual } from 'modules/enumerations/enumerationHelpers';
import {
  Grid,
} from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import {
  getAuthDestinationServices,
  updateAuthDestinationServicesBuyer,
} from 'modules/authorizations/store/actions/destinationService.actions';
export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

const BuyerPreferencesCard = (props) => {
  const { buyerDetails, authId, hideEdit, enumerations } = props;
  const [isLoading, setIsLoading] = useState(false);
  const isFailure = r => r?.type?.endsWith('_FAILURE');

  const familiarWithAreaOptions = [...(enumerations?.familiarWithAreaTypes || [])]
    .sort((first, second) => Number(first.additionalField) - Number(second.additionalField));

  const buyerPreferencesTabs = [
    { header: 'Buyer Preferences', order: 1, iconPath: ['fas', 'fa-truck-moving'] },
  ];

  const currencyOptions = getCurrencyOptions(enumerations?.currencies, CURRENCY_LABEL_FORMATS.LONG);
  const selectedCurrency = currencyOptions.find(currency =>
    isIdEqual(currency.id, buyerDetails?.payInCurrencyId) || isIdEqual(currency.code, buyerDetails?.payInCurrencyId)
  );
  const defaultCurrency = currencyOptions.find(currency => currency.code === 'USD');
  const currencyValue = selectedCurrency?.id || defaultCurrency?.id || '';
  const ageOfHomeOrder = ['new', '1-5', '5-10', '10+', 'vintag'];
  const ageOfHomeOptions = [...(enumerations?.ageOfHomes || [])].sort((first, second) => {
    const firstIndex = ageOfHomeOrder.findIndex(order => first.title?.toLowerCase().startsWith(order));
    const secondIndex = ageOfHomeOrder.findIndex(order => second.title?.toLowerCase().startsWith(order));
    const normalizedFirstIndex = firstIndex === -1 ? ageOfHomeOrder.length : firstIndex;
    const normalizedSecondIndex = secondIndex === -1 ? ageOfHomeOrder.length : secondIndex;

    return normalizedFirstIndex - normalizedSecondIndex;
  });
  const buyerPreferencesSummaries = [
    {
      header: 'Service Start Date',
      accessorKey: 'serviceInitiationDate',
      type: 'date',
      value: buyerDetails?.serviceInitiationDate,
      tab: 1,
      hideInModal: true
    },
    { header: 'Currency', accessorKey: 'payInCurrencyId', type: 'dropdown-v2', required: false, value: currencyValue, options: currencyOptions, tab: 1 },
    { header: 'Min Price', accessorKey: 'priceRangeMin', type: 'money', required: false, value: buyerDetails ? buyerDetails.priceRangeMin : '', tab: 1 },
    { header: 'Max Price', accessorKey: 'priceRangeMax', type: 'money', required: false, value: buyerDetails ? buyerDetails.priceRangeMax : '', tab: 1 },
    { header: 'Bedroom Preference', accessorKey: 'numBedrooms', type: 'number', required: false, value: buyerDetails ? buyerDetails.numBedrooms : 0, tab: 1 },
    { header: 'Bathroom Preference', accessorKey: 'numBathrooms', type: 'number', required: false, value: buyerDetails ? buyerDetails.numBathrooms : 0, tab: 1 },
    // { header: 'Type of Home', accessorKey: 'typeOfHomeId', type: 'dropdown-v2', required: false, value: buyerDetails ? buyerDetails.homeTypeId : '', options: enumerations ? enumerations.typeOfHomes : [], tab: 1 },
    { header: 'Age of Home', accessorKey: 'ageOfHomeId', type: 'dropdown-v2', required: false, value: buyerDetails ? buyerDetails.ageOfHomeId : '', options: ageOfHomeOptions, tab: 1 },
    { header: 'Square Footage', accessorKey: 'squareFeet', type: 'number', required: false, value: buyerDetails ? buyerDetails.squareFeet : 0, tab: 1 },
    { header: 'Property Type', accessorKey: 'propertyTypeId', type: 'dropdown-v2', required: false, value: buyerDetails ? buyerDetails.propertyTypeId : '', options: enumerations ? enumerations.propertyTypes : [], tab: 1 },
    { header: 'Familiar With Area?', accessorKey: 'familiarWithAreaTypeId', type: 'dropdown-v2', required: false, value: buyerDetails?.familiarWithAreaTypeId ?? '', options: familiarWithAreaOptions, tab: 1 },
    { header: 'Fireplace', accessorKey: 'fireplace', type: 'dropdown', options: ["Yes", "No", "No Preference"], required: false, value: buyerDetails ? buyerDetails.fireplace : '', tab: 1 },
    { header: 'Garage', accessorKey: 'garage', type: 'dropdown', options: ["Yes", "No", "No Preference"], required: false, value: buyerDetails ? buyerDetails.garage : '', tab: 1 },
    { header: 'Basement', accessorKey: 'basement', type: 'dropdown', options: ["Yes", "No", "No Preference"], required: false, value: buyerDetails ? buyerDetails.basement : '', tab: 1 },
    { header: 'School Request', accessorKey: 'hasSchoolRequest', type: 'checkbox', required: false, value: buyerDetails ? buyerDetails.hasSchoolRequest : false, tab: 1 },
    {
      header: 'School Request Note', accessorKey: 'schoolRequestNote', type: 'text', required: false, value: buyerDetails ? buyerDetails.schoolRequestNote : '', tab: 1,
      showWhen: () => {
        return buyerDetails && buyerDetails.hasSchoolRequest === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasSchoolRequest === true;
      }
    },
    { header: 'Special Needs and Important Features', accessorKey: 'specialNeeds', type: 'text', required: false, value: buyerDetails ? buyerDetails.specialNeeds : '', tab: 1 },
    {
      header: 'Canceled Date',
      accessorKey: 'serviceCanceledDate',
      type: 'date',
      value: buyerDetails?.serviceCanceledDate || null,
      tab: 1
    },
    { dividerLine: true, tab: 1 },
    { header: 'Preferred Agent', accessorKey: 'hasPreferredAgent', type: 'checkbox', required: false, value: buyerDetails ? buyerDetails.hasPreferredAgent : false, tab: 1 },
    {
      header: 'Preferred Agent Name', accessorKey: 'preferredAgentName', type: 'text', required: false, value: buyerDetails ? buyerDetails.preferredAgentName : '', tab: 1,
      showWhen: () => {
        return buyerDetails && buyerDetails.hasPreferredAgent === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasPreferredAgent === true;
      }
    },
    {
      header: 'Preferred Agency', accessorKey: 'preferredAgency', type: 'text', required: false, value: buyerDetails ? buyerDetails.preferredAgency : false, tab: 1,
      showWhen: () => {
        return buyerDetails && buyerDetails.hasPreferredAgent === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasPreferredAgent === true;
      }
    },
    {
      header: 'Preferred Agency Email', accessorKey: 'preferredAgencyEmail', type: 'text', required: false, value: buyerDetails ? buyerDetails.preferredAgencyEmail : false, tab: 1,
      showWhen: () => {
        return buyerDetails && buyerDetails.hasPreferredAgent === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasPreferredAgent === true;
      }
    },
    {
      header: 'Preferred Agency Phone', accessorKey: 'preferredAgencyPhone', type: 'text', required: false, value: buyerDetails ? buyerDetails.preferredAgencyPhone : false, tab: 1,
      showWhen: () => {
        return buyerDetails && buyerDetails.hasPreferredAgent === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasPreferredAgent === true;
      }
    }
  ];

  const updateRenterPreferences = async (tab, values) => {
    setIsLoading(true);
    const payload = {
      ...buyerDetails,
      authorizationFileId: Number(authId) || 0,
      payInCurrencyId: !values.payInCurrencyId || values.payInCurrencyId === '' ? ZERO_GUID : values.payInCurrencyId,
      typeOfHomeId: !values.typeOfHomeId || values.typeOfHomeId === '' ? ZERO_GUID : values.typeOfHomeId,
      ageOfHomeId: !values.ageOfHomeId || values.ageOfHomeId === '' ? ZERO_GUID : values.ageOfHomeId,
      propertyTypeId: !values.propertyTypeId || values.propertyTypeId === '' ? ZERO_GUID : values.propertyTypeId,
      priceRangeMin: values.priceRangeMin === '' || values.priceRangeMin == null ? null : Number(values.priceRangeMin),
      priceRangeMax: values.priceRangeMax === '' || values.priceRangeMax == null ? null : Number(values.priceRangeMax),
      numBedrooms: values.numBedrooms === '' || values.numBedrooms == null ? null : parseInt(values.numBedrooms, 10),
      numBathrooms: values.numBathrooms === '' || values.numBathrooms == null ? null : parseInt(values.numBathrooms, 10),
      squareFeet: values.squareFeet != null ? String(values.squareFeet) : '',
      familiarWithAreaTypeId: values.familiarWithAreaTypeId || null,
      fireplace: values.fireplace ?? '',
      garage: values.garage ?? '',
      basement: values.basement ?? '',
      schoolRequestNote: values.schoolRequestNote ?? '',
      hasPreferredAgent: values.hasPreferredAgent ?? false,
      preferredAgentName: values.preferredAgentName ?? '',
      preferredAgency: values.preferredAgency ?? '',
      preferredAgencyEmail: values.preferredAgencyEmail ?? '',
      preferredAgencyPhone: values.preferredAgencyPhone ?? '',
      // mortgageLenderSelected: values.mortgageLenderSelected ?? '',
      specialNeeds: values.specialNeeds ?? '',
      hasSchoolRequest: values.hasSchoolRequest ?? false,
      addedOn: buyerDetails ? buyerDetails.addedOn : new Date(),
      modifiedOn: new Date(),
    };
    console.log(payload)

    const resp = await props.updateAuthDestinationServicesBuyer(authId, payload);

    if (isFailure(resp)) {
      props.showToast('Failed to update the buyer destination services info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      // await props.getAuthDestinationServices(authId);
      setIsLoading(false);
      return true;
    }
  };

  return (
    <Grid item sx={{ marginBottom: '10px' }}>
      <EditableCard
        tabs={buyerPreferencesTabs}
        summaries={buyerPreferencesSummaries}
        numColumns={5}
        updateFields={updateRenterPreferences}
        isLoading={isLoading}
        hideEdit={hideEdit}
      />
    </Grid>
  );

};

// BuyerPreferencesCard.propTypes = {
//   classes: PropTypes.object.isRequired,
// }

const mapStateToProps = (state) => {
  return {
  };
};

export default compose(
  connect(mapStateToProps, {
    updateAuthDestinationServicesBuyer,
    getAuthDestinationServices,
    showToast,
  }),
)(BuyerPreferencesCard);